import { useState } from "react";
import { motion } from "framer-motion";
import "./TestimonialSlider.scss";

// Assets
import play from "../../assets/Images/Home/Testimonials/play.svg";
import thumb1 from "../../assets/Images/Home/Testimonials/img1.png";
import thumb2 from "../../assets/Images/Home/Testimonials/img2.png";
import thumb3 from "../../assets/Images/Home/Testimonials/img3.png";
import thumb4 from "../../assets/Images/Home/Testimonials/img4.png";
import thumb5 from "../../assets/Images/Home/Testimonials/img5.png";
import cluster from "../../assets/Images/Engineering/cluster.svg";

// --- DATA ---

const VIDEO_TESTIMONIALS = [
  { id: "v1", name: "Cody Fisher", role: "CEO at ABC Company", videoUrl: "https://www.youtube.com/embed/LXb3EKWsInQ", thumbnail: thumb1 },
  { id: "v2", name: "Wade Warren", role: "CEO at ABC Company", videoUrl: "https://www.youtube.com/embed/JFcgOboQZ08", thumbnail: thumb2 },
  { id: "v3", name: "Esther Howard", role: "CEO at ABC Company", videoUrl: "https://www.youtube.com/embed/ysz5S6PUM-U", thumbnail: thumb3 },
  { id: "v4", name: "Justin Arenson", role: "CEO at ABC Company", videoUrl: "https://www.youtube.com/embed/7X8II6J-6mU", thumbnail: thumb4 },
  { id: "v5", name: "Brooklyn Simmons", role: "CEO at ABC Company", videoUrl: "https://www.youtube.com/embed/LXb3EKWsInQ", thumbnail: thumb5 },
];

// --- COMPONENTS ---

// 1. Reusable Marquee Component
// Handles the infinite loop and "Pause on Hover" independently
const MarqueeGroup = ({ children, duration = "40s" }) => {
  return (
    <div className="ht-marquee-wrapper">
      <div 
        className="ht-marquee-track" 
        style={{ animationDuration: duration }}
      >
        <div className="ht-marquee-content">{children}</div>
        <div className="ht-marquee-content">{children}</div>
        <div className="ht-marquee-content">{children}</div>
      </div>
      <div className="ht-marquee-fade-overlay"></div>
    </div>
  );
};

// 2. Main Parent Component
export default function TestimonialsCarousel() {
  const [playingVideo, setPlayingVideo] = useState(null);

  const handlePlayVideo = (id) => {
    setPlayingVideo((prev) => (prev === id ? null : id));
  };

  return (
    <section className="ht-testimonials-section">
      <div className="ht-container-custom">
        <div className="ht-section-header">
          <div className="ht-capsule">
            <div className="icon-wrapper">
              <div className="icon-blur" aria-hidden="true"></div>
              <img src={cluster} alt="cluster" className="capsule-icon" />
            </div>
            <span>Testimonials</span>
          </div>

          <h2>
            The Customer is Hero of <br />
            <span className="ht-highlight">Our Business</span>
          </h2>
        </div>
      </div>


      {/* Row 2: Video Testimonials (Faster Speed: 30s) */}
      <MarqueeGroup duration="30s">
        {VIDEO_TESTIMONIALS.map((item, index) => (
          <VideoCard
            key={`video-${index}`}
            item={item}
            isPlaying={playingVideo === item.id}
            onPlay={() => handlePlayVideo(item.id)}
          />
        ))}
      </MarqueeGroup>
    </section>
  );
}

// 3. Video Card Component (Handles Hover Expansion)
const VideoCard = ({ item, isPlaying, onPlay }) => {
  const [isHovered, setIsHovered] = useState(false);

  // Define widths
  const baseWidth = 250;
  const expandedWidth = 400; // Width on hover

  return (
    <motion.div
      className={`ht-video-card ${isPlaying ? "ht-playing" : ""}`}
      onMouseEnter={() => setIsHovered(true)}
      onMouseLeave={() => setIsHovered(false)}
      onClick={() => !isPlaying && onPlay()}
      
      // Framer Motion Animation
      animate={{
        width: isPlaying ? 511 : (isHovered ? expandedWidth : baseWidth),
        opacity: 1
      }}
      transition={{ type: "spring", stiffness: 300, damping: 30 }}
      style={{ 
        height: 324, 
        overflow: "hidden", 
        borderRadius: 20,
        position: "relative",
        flexShrink: 0 // Crucial for flex containers
      }}
    >
      <div className="ht-video-wrapper">
        {isPlaying ? (
          <iframe
            src={`${item.videoUrl}?autoplay=1&mute=0&controls=1&rel=0&showinfo=0&modestbranding=1`}
            title={item.name}
            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
            className="ht-bg-video-iframe ht-playing"
            allowFullScreen
          ></iframe>
        ) : (
          <img
            src={item.thumbnail}
            alt={item.name}
            className="ht-bg-video-iframe"
            style={{ objectFit: "cover", opacity: 0.8 }}
            loading="lazy"
          />
        )}

        {/* Overlay - Hide when playing */}
        {!isPlaying && (
          <motion.div 
            className="ht-video-overlay"
            animate={{ opacity: 1 }}
          >
            <div className="ht-play-button">
              <img src={play} alt="Play" />
            </div>
            <div className="ht-video-info">
              {/* Hide text on hover if it gets too cramped, or keep it */}
              <motion.div animate={{ opacity: 1 }}>
                <h4>{item.name}</h4>
                <p>{item.role}</p>
              </motion.div>
            </div>
          </motion.div>
        )}
      </div>
    </motion.div>
  );
};